import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { displayBooleanString } from 'ctm-util-functions';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';

export const getSecurityFeatures = (props) => {
    const { securityFeatures } = props;
    return securityFeatures ? getSecurityLabel(securityFeatures) : null;
};

export const getSecurityLabel = (value) => ({
    NONE: 'No security features',
    ALARM: 'Alarm',
    IMMOBILISER: 'Immobiliser',
    BOTH: 'Alarm & Immobiliser'
}[value]);

export const getFinanceLabel = (value) => ({
    FINANCE_HIRE_PURCHASE: 'Yes, Finance / Hire Purchase',
    LEASE: 'Yes, Lease',
    NONE: 'No Finance'
}[value]);

export const getUsageTypeLabel = (value) => ({
    PRIVATE_AND_COMMUTING_TO_WORK: 'Private and/or commuting to work only',
    PRIVATE_OCCASIONAL_BUSINESS: 'Private and Occasional Business',
    PRIVATE_BUSINESS: 'Private and Business',
    BUSINESS_ONLY: 'Business Only'
}[value]);

export const getPreviousInsurerLabel = (value) => ({
    FIRST_FOR_WOMEN: '1st for Women',
    AAMI: 'AAMI',
    AAI_LIMITED: 'AAI Limited',
    ALLIANZ: 'Allianz',
    ANZ: 'ANZ',
    APIA: 'APIA',
    AUTO_GENERAL: 'Auto & General',
    AUSSIE: 'Aussie',
    AUS_POST: 'Australia Post Insurance',
    BOQ_INSURANCE: 'Bank of Queensland Insurance',
    BENDIGO_BANK: 'Bendigo Bank',
    BINGLE: 'Bingle',
    BUDGET_DIRECT: 'Budget Direct',
    BUPA_INSURANCE: 'BUPA Insurance',
    CARPEESH: 'Carpeesh',
    CGU: 'CGU',
    COLES_INSURANCE: 'Coles Insurance',
    COMMINSURE: 'Comminsure',
    ELDERS_INSURANCE: 'Elders Insurance',
    ERIC_INSURANCE: 'Eric Insurance',
    GIO: 'GIO',
    HBF_INSURANCE: 'HBF Insurance',
    HOLLARD: 'Hollard',
    HUDDLE: 'Huddle',
    ING: 'ING',
    JUST_CAR_INSURANCE: 'Just Car Insurance',
    KOBA: 'Koba',
    LUMLEY: 'Lumley',
    NAB: 'NAB',
    NRMA: 'NRMA',
    OCEANIA_INSURANCE: 'Oceania Insurance',
    OZICARE: 'Ozicare',
    PD_INSURANC: 'PD Insurance',
    QANTAS_INSURANCE: 'Qantas Insurance',
    QBE: 'QBE',
    RAA: 'RAA',
    RAC: 'RAC',
    RACQ: 'RACQ',
    RACT: 'RACT',
    RACV: 'RACV',
    REAL_INSURANCE: 'Real Insurance',
    RETIREASE: 'Retirease',
    SGIC: 'SGIC',
    SGIO: 'SGIO',
    SHANNONS: 'Shannons',
    STELLA: 'Stella',
    ST_GEORGE_BANK: 'St George Bank',
    SUNCORP: 'Suncorp',
    SWANN: 'Swann',
    VERO: 'Vero',
    VIRGIN_MONEY_INSURANCE: 'Virgin Money Insurance',
    WFI: 'WFI',
    WESTPAC: 'Westpac',
    WOOLWORTHS: 'Everyday Insurance',
    YOUI: 'YOUI',
    ZURICH: 'Zurich',
    OTHER: 'Other/Not Listed'
}[value]);

const _CoverDetails = (props) => {
    const { damaged, annualKilometres, finance, currentlyInsured, useType, previousInsurer } = props;

    return (
        <QuoteCard title="Cover details" path="accident_hail_damage">
            <QuoteQuestionPlainItem title="Damage" content={displayBooleanString(damaged)} />
            <QuoteQuestionPlainItem title="Security" content={getSecurityFeatures(props)} />
            <QuoteQuestionPlainItem title="Financed" content={getFinanceLabel(finance)} />
            <QuoteQuestionPlainItem title="KM Per year" content={annualKilometres && parseFloat(annualKilometres).toLocaleString()} />
            <QuoteQuestionPlainItem title="How the car is used" content={getUsageTypeLabel(useType)} />
            <QuoteQuestionPlainItem title="Currently insured" content={displayBooleanString(currentlyInsured)} />
            <QuoteQuestionPlainItem title="Previous Insurer" content={(currentlyInsured === 'Y') && getPreviousInsurerLabel(previousInsurer)} />
        </QuoteCard>
    );
};

_CoverDetails.propTypes = {
    damaged: PropTypes.string,
    securityFeatures: PropTypes.string,
    finance: PropTypes.string,
    currentlyInsured: PropTypes.string,
    previousInsurer: PropTypes.string,
    annualKilometres: PropTypes.string,
    useType: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        damaged: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'damaged']),
        securityFeatures: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'securityFeatures']) || '',
        finance: quoteFormSelector(state).getIn(['coverDetail', 'financeType']),
        currentlyInsured: quoteFormSelector(state).getIn(['coverDetail', 'currentlyInsured']),
        previousInsurer: quoteFormSelector(state).getIn(['coverDetail', 'previousInsurer']),
        annualKilometres: quoteFormSelector(state).getIn(['coverDetail', 'annualKilometres']),
        useType: quoteFormSelector(state).getIn(['coverDetail', 'useType'])
    };
};

const CoverDetails = connect(mapStateToProps)(_CoverDetails);

export { CoverDetails, _CoverDetails };
